import numeral from 'numeral';

const count = (fees: string[]) => {
	return fees.reduce((acc, value) => acc.add(value), numeral(0)).format('0.00');
};

const countPlan = (plan: types.services.fixed.IPlan, additionalServices: types.services.fixed.IAdditionalService[]) => {
	const fees = [plan.fee, ...additionalServices.map(({ monthlyFee }) => monthlyFee)];
	if (fees.some((fee) => !fee)) return '0.000';

	return count(fees.map((fee) => (!!fee ? fee : '0')));
};

export { countPlan, count };
